<template>
  <div
    class="contentPage"
    v-if="tableList"
    v-loading.fullscreen.lock="pageLoading"
    element-loading-text="拼命加载中"
  >
    <div class="buttons">
      <div>
        <el-button
          type="primary"
          icon="el-icon-plus"
          size="small"
          @click="drawerPage(null, 'add')"
          element-loading-text="拼命加载中"
          v-if="btnPermission.includes('SUBMIT')"
          >新增</el-button
        >
        <el-button
          style="background: #f2f3f5"
          icon="el-icon-delete"
          size="small"
          @click="handleDelList"
          v-if="btnPermission.includes('DELETE')"
          >删除</el-button
        >
        <el-button
          size="small"
          style="background: #f2f3f5"
          @click="upLoadFile"
          v-if="btnPermission.includes('IMPORT')"
        >
          <svg-icon
            icon-class="icon_import"
            style="font-size: 14px; vertical-align: bottom"
          ></svg-icon>
          导入
        </el-button>
        <el-button
          size="small"
          @click="handleExport"
          style="background: #f2f3f5"
          :loading="exportLoading"
          v-if="btnPermission.includes('EXPORT')"
        >
          <svg-icon
            icon-class="icon_export"
            style="font-size: 14px; vertical-align: bottom"
          ></svg-icon>
          导出</el-button
        >
      </div>
      <div style="float: right; width: fit-content">
        <el-select
          v-if="sublist.length > 1"
          v-model="_defaultTable"
          placeholder="请选择"
          size="small"
          style="width: 100px; margin-right: 20px"
        >
          <el-option
            v-for="item in sublist"
            :key="item.value"
            :label="item.formName"
            :value="item.id"
          >
          </el-option>
        </el-select>

        <el-button
          type="text"
          style="color: #4e5969"
          size="small"
          @click="getViewList"
        >
          <svg-icon
            icon-class="icon_refresh"
            style="font-size: 14px; vertical-align: bottom"
          ></svg-icon>
          刷新</el-button
        >
      </div>
    </div>
    <el-table
      :data="tableList.data.records"
      @sort-change="handleSort"
      @selection-change="handleSelectionChange"
      stripe
      :header-cell-style="headerCellStyle"
      :cell-style="cellStyle"
      border
      height="100%"
      v-loading="loading"
      style="flex: 1"
    >
      <el-table-column
        type="selection"
        width="50"
        align="center"
        fixed
      ></el-table-column>
      <el-table-column
        type="index"
        width="60"
        align="center"
        label="序号"
        :index="seIindex"
        fixed
      >
      </el-table-column>
      <el-table-column
        prop="Name"
        label="数据标题"
        align="center"
        fixed
        :width="flexColumnWidth('数据标题', tableList.data.records, 'Name')"
      >
        <template #default="{ row }">
          <div @click="drawerPage(row, 'see')">
            <span href="#" style="cursor: pointer">
              <ellipsis hoverTip :row="1" :content="row.Name"> </ellipsis>
            </span>
          </div>
        </template>
      </el-table-column>
      <el-table-column
        :sortable="sortable(item)"
        v-for="item in tableList.field"
        :fixed="lockList.includes(item.code) || false"
        :key="item.itemId"
        :prop="item.code"
        :label="item.title"
        align="center"
        :width="
          ['Created', 'Updated', 'DateTime'].includes(item.code)
            ? '180px'
            : tableList.field.length < 5
            ? 'auto'
            : flexColumnWidth(item.title, tableList.data.records, item.code)
        "
        show-overflow-tooltip
      >
        <template #header="{ column }">
          <span style="">
            <span>{{ column.label }}</span>
            <img
              src="https://ybr-file.oss-cn-shanghai.aliyuncs.com/ylab/resume/2025/12/23/锁定 (1)-110121697.png"
              v-if="lockList.includes(item.code)"
              alt=""
              class="icon"
              style=""
              @click.stop="handleLock(item)"
            />
            <img
              src="https://ybr-file.oss-cn-shanghai.aliyuncs.com/ylab/resume/2025/12/23/解锁 (1)-110121706.png"
              alt=""
              class="icon"
              style=""
              v-else
              @click.stop="handleLock(item)"
            />
          </span>
        </template>
        <template #default="{ row }">
          <div v-if="item.name === 'ImageUpload'">
            <el-image
              v-for="(url, urlI) in row[item.code]"
              :key="urlI"
              style="width: 40px; height: 40px"
              :src="url.url"
              :preview-src-list="[url.url]"
            ></el-image>
          </div>
          <div v-else-if="item.name === 'FileUpload'">
            <div
              v-for="(url, urlI) in row[item.code]"
              :key="urlI"
              style="width: fit-content; cursor: pointer"
              @click="preview(url)"
            >
              <el-tooltip
                class="item"
                effect="dark"
                :content="url.name"
                placement="top"
              >
                <img
                  src="https://ybr-file.oss-cn-shanghai.aliyuncs.com/ylab/resume/2025/07/08/pdf-114939470.png"
                  alt=""
                  style="width: 28px; height: 28px"
                  v-if="url.name.includes('.pdf')"
                />
                <img
                  src="https://ybr-file.oss-cn-shanghai.aliyuncs.com/ylab/resume/2025/07/08/zip-114939537.png"
                  alt=""
                  style="width: 28px; height: 28px"
                  v-else-if="url.name.includes('.zip')"
                />
                <img
                  src="https://ybr-file.oss-cn-shanghai.aliyuncs.com/ylab/resume/2025/07/08/word-114939474.png"
                  alt=""
                  style="width: 28px; height: 28px"
                  v-else
                />
              </el-tooltip>
            </div>
          </div>
          <div
            v-else
            @click="toDetail(row, item)"
            style="
              display: block;
              word-break: break-all;
              overflow: hidden;
              text-overflow: ellipsis;
              -webkit-line-clamp: 1;
              line-clamp: 1;
              -webkit-box-orient: vertical;
              white-space: nowrap;
              overflow: hidden;
              text-overflow: ellipsis;
            "
            :class="{ relevance: isToDetail.includes(item.name) }"
          >
            {{ row[item.code] }}
          </div>
        </template>
        <el-table-column
          v-for="k in item.items"
          :key="k.code"
          :prop="k.code"
          :label="k.title"
          align="center"
          :min-width="
            ['Created', 'Updated', 'DateTime'].includes(k.code)
              ? '180px'
              : flexColumnWidth(
                  k.title,
                  tableList.data.records[item.code],
                  k.code
                )
          "
          show-overflow-tooltip
        >
          <template #default="{ row }">
            <div v-for="(num, i) in row[k.formId].slice(0, 4)" :key="i">
              <div>
                <el-image
                  v-if="
                    row[k.formId][i][k.code] &&
                    ['png', 'jpg'].includes(
                      row[k.formId][i][k.code]
                        .toString()
                        .substring(
                          row[k.formId][i][k.code].toString().length - 3
                        )
                    )
                  "
                  :src="row[k.formId][i][k.code]"
                  alt=""
                  style="width: 80px; height: 80px"
                />
                <div v-else>
                  {{ row[k.formId][i][k.code] }}
                </div>
              </div>
            </div>
            <div v-if="row[k.formId].length > 4">······</div>
          </template>
        </el-table-column>
      </el-table-column>
    </el-table>
    <el-dialog title="人员信息" :visible.sync="userInfoDialog" width="600px">
      <div style="display: flex" v-if="userInfoDialog">
        <div style="display: flex; margin: auto">
          <el-image
            style="width: 150px; height: 150px; border-radius: 20px"
            :src="userInfo.avatar"
            v-if="userInfo.avatar"
          ></el-image>
          <span
            v-else
            style="
              text-align: center;
              line-height: 150px;
              background: #1890ff;
              color: white;
              margin-left: 10px;
              display: block;
              width: 150px;
              height: 150px;
              border-radius: 20px;
              font-size: 40px;
            "
            >{{
              userInfo.name && userInfo.name.split("-").length > 1
                ? userInfo.name
                    .split("-")[0]
                    .slice(
                      userInfo.name.split("-")[0].length - 2,
                      userInfo.name.split("-")[0].length
                    )
                : userInfo.name.slice(
                    userInfo.name.length - 2,
                    userInfo.name.length
                  )
            }}</span
          >
          <div style="margin-left: 100px">
            <ul
              style="
                display: flex;
                flex-direction: column;
                justify-content: space-between;
                height: 100%;
              "
            >
              <li>姓名：{{ userInfo.name }}</li>
              <li>员工工号：{{ userInfo.jobNum }}</li>
              <li>职位：{{ userInfo.position }}</li>
              <li>部门：{{ userInfo.deptName }}</li>
              <li>联系方式：{{ userInfo.phone }}</li>
            </ul>
          </div>
        </div>
      </div>
    </el-dialog>
    <FileUpLoad :upLoadFileDialog.sync="upLoadFileDialog"></FileUpLoad>
  </div>
</template>

<script>
import { getUserInfo } from "@/api/org";
import FileUpLoad from "@/components/common/FileUpLoad";

import {
  flexColumnWidth,
  rowStyle,
  cellStyle,
  headerCellStyle,
} from "@/utils/CustomUtil.js";
import { pageListDel } from "@/api/drawerPage";

import { pageViewListExport } from "@/api/process";
import { download } from "@/utils/export.js";
import { getFileUrl } from "@/api/drawerPage";
export default {
  props: {
    tableList: {
      require: true,
      default: () => {},
    },
    formData: {
      type: Object,
      default: () => {},
    },
    pageNumber: {
      type: Number,
      default: 0,
    },
    pageSize: {
      type: Number,
      default: 10,
    },
    sublist: {
      type: Array,
      default: () => [],
    },
    defaultTable: {
      type: String,
      default: "",
    },
  },
  inject: {
    getViewList: "getViewList",
  },
  components: { FileUpLoad },
  computed: {
    _defaultTable: {
      get() {
        return this.defaultTable;
      },
      set(val) {
        this.$emit("update:defaultTable", val);
        this.getViewList(null, null, false);
      },
    },
    btnPermission() {
      return this.$store.state.formData.externalBtnPermission;
    },
    lockList() {
      const list = this.$store.state.formData.lockList || [];
      if (list) {
        return (
          list.find((item) => item.id === this.$route.query.code)?.codes || []
        );
      }
      return [];
    },
  },
  data() {
    return {
      loading: false,
      pageLoading: false,
      isToDetail: ["Relevance", "CreatedBy"],
      userInfoDialog: false,
      userInfo: {},
      upLoadFileDialog: false,
      exportLoading: false,
    };
  },

  methods: {
    async preview(file) {
      // 下载文件
      const a = document.createElement("a");
      const res = await getFileUrl(file.id);
      if (res) {
        a.href = res.data;
      }
      a.download = file.name;
      a.target = "_blank";
      a.click();
      a.remove();
    },
    handleLock(item) {
      if (this.lockList.find((el) => el === item.code)) {
        const data = {
          id: this.$route.query.code,
          codes: this.lockList.filter((el) => el !== item.code),
        };
        this.$store.commit("formData/setLockList", data);
      } else {
        const data = {
          id: this.$route.query.code,
          codes: [...this.lockList, item.code],
        };
        this.$store.commit("formData/setLockList", data);
      }
    },
    async handleExport() {
      let ids = [];
      this.$store.state.formData.multipleSelection.forEach((item) => {
        ids.push(item.id);
      });
      let data = {
        formId: this.$route.query.code,
        pageNumber: 1,
        pageSize: 9999,
        searchParamsJson: this.formData,
        subFormId: this.$store.state.tableChecked,
        ids,
      };
      this.exportLoading = true;
      const res = await pageViewListExport(data);
      download(res, this.$store.getters.formName);
      this.$message.success("导出成功");
      this.exportLoading = false;
    },

    seIindex(i) {
      return i + 1 + (this.pageNumber - 1) * this.pageSize;
    },
    // 看详情
    async toDetail(row, item) {
      if (!this.isToDetail.includes(item.name)) return;
      let code = row[`${item.code}Id`];
      if (item.name === "Relevance") {
        this.pageLoading = true;
        let data = await this.$store.dispatch("formData/getDetailData", {
          formId: item.options,
          id: code,
          type: "see",
        });
        // 重置页面栈
        this.$store.commit("formData/setPageNameList", data);
        this.pageLoading = false;
      } else {
        let res = await getUserInfo(code);
        this.userInfo = res.data;
        this.userInfoDialog = true;
      }
    },
    sortable(item) {
      let canSort = ["Updated", "DateTime", "Created", "AmountInput"];
      if (canSort.includes(item.name)) {
        return "custom";
      } else {
        return false;
      }
    },
    // 设置单元格样式
    cellStyle,
    // 根据不同表单设置颜色
    rowStyle,
    //自适应宽度
    flexColumnWidth,
    // 设置表头单元格样式
    headerCellStyle,
    handleSelectionChange(val) {
      this.$store.commit("formData/setMultipleSelection", val);
    },
    handleSort(column) {
      this.getViewList(
        column.prop,
        column.order === "ascending" ? "asc" : "desc",
        false
      );
    },

    async drawerPage(row, type) {
      this.pageLoading = true;
      let result = await this.$store.dispatch("formData/getDetailData", {
        formId: this.$route.query.code,
        id: row ? row.id : "",
        type,
      });
      if (type === "see") {
        this.$store.commit("formData/setPageNameList", result);
      }
      this.pageLoading = false;
    },
    handleDelList() {
      if (this.$store.state.formData.multipleSelection.length < 1) return;
      this.$confirm("此操作将永久删除该表单, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(async () => {
          let res = [];
          this.$store.state.formData.multipleSelection.forEach((item) => {
            res.push(item.id);
          });
          if (res.length > 1) this.$emit("update:pageNumber", 1);
          await pageListDel(this.$route.query.code, res);
          this.getViewList(null, null, false);
          this.$message.success("删除成功!");
        })
        .catch(() => {
          this.$message.info("取消删除!");
        });
    },
    upLoadFile() {
      this.upLoadFileDialog = true;
    },
  },
};
</script>

<style lang="less" scoped>
.contentPage {
  width: 100%;
  height: 100%;
  background: #fff;
  display: flex;
  flex-direction: column;
}

.relevance {
  cursor: pointer;
  color: #107fff;
}

.buttons {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 18px;
  .el-button {
    // width: 82px !important;
    height: 32px !important;
    font-size: 14px;
    border-color: transparent !important;
  }
  /deep/.el-button--small {
    padding: 9px 17px;
  }
}

/deep/.el-table th.el-table__cell > .cell {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  .icon {
    width: 16px;
    height: 16px;
    cursor: pointer;
    float: right;
    margin-top: 3px;
    display: none;
    opacity: 0;
    transition: all 0.3s;
  }
  &:hover {
    .icon {
      display: block;
      opacity: 1;
    }
  }
}
/deep/.el-table th.el-table__cell.is-sortable {
  .icon {
    margin-top: 8px;
  }
}
</style>
